// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3641":"6dce7c70","4391":"af5505fd"}[chunkId] + ".chunk.css";
};